import { render } from "./videoShowtype.vue?vue&type=template&id=23388a62&scoped=true"
import script from "./videoShowtype.vue?vue&type=script&lang=js"
export * from "./videoShowtype.vue?vue&type=script&lang=js"

import "./videoShowtype.vue?vue&type=style&index=0&id=23388a62&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23388a62"]])

export default __exports__